import Vue from 'vue' ;
import {Message} from 'element-ui';
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame';
import home from '@/pages/home/index';
import login from '@/pages/login/index';
// 客户管理
import customer from '@/pages/customer/frame'//外层架子；
import customerList from '@/pages/customer/list';
import customerYh from '@/pages/customer/yhList';
import customerDetail from '@/pages/customer/detail';//品牌商详情改为公用的这个；


//版本管理
import version from '@/pages/version/index';
//app页面管理
import appPage from '@/pages/appPage/frame'//外层架子；
import appHomeSet from '@/pages/appPage/appHomeSet';
import messageContent from '@/pages/appPage/messageContent';
import servicePercent from '@/pages/appPage/servicePercent';

//系统管理
import system from '@/pages/system/frame';//外层架子；
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';
//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:true,matchLeftKey:'/home'}
        },
        
        {
          path: '/version',
          name: 'version',
          component: version,
          meta:{title:'版本管理',isShowBread:true,matchLeftKey:'/version'}
        },
        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        {
          path: '/customer',
          name: 'customer',
          component: customer,
          meta:{title:'客户管理'},
          children:[
            {
              path: 'list',
              name: 'customerList',
              component: customerList,
              meta:{title:'客户列表',isShowBread:true,matchLeftKey:'/customer/list'}
            },
            {
              path: 'yh',
              name: 'customerYh',
              component: customerYh,
              meta:{title:'余杭区客户',isShowBread:true,matchLeftKey:'/customer/yh'}
            },
            
            {
              path: 'detail/:userId',
              name: 'customerDetail',
              component: customerDetail,
              meta:{title:'客户详情',isShowBack:true,isShowBread:true,matchLeftKey:'/customer/list'}
            },
          ]
        },
        {
          path: '/appPage',
          name: 'appPage',
          component: appPage,
          meta:{title:'页面管理'},
          children:[
            {
              path: 'appHomeSet',
              name: 'appHomeSet',
              component: appHomeSet,
              meta:{title:'app首页设置',isShowBread:true,matchLeftKey:'/appPage/appHomeSet'}
            },
            {
              path: 'messageContent',
              name: 'messageContent',
              component: messageContent,
              meta:{title:'认证短信设置',isShowBread:true,matchLeftKey:'/appPage/messageContent'}
            },
            {
              path: 'servicePercent',
              name: 'servicePercent',
              component: servicePercent,
              meta:{title:'服务费设置',isShowBread:true,matchLeftKey:'/appPage/servicePercent'}
            },
          ]
        },
        
        //系统管理
        {
          path:'/system',
          name:'system',
          component:system,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]
          
        }
       
      ]
    },
    // {
    //     path: '*',
    //     redirect: '/404'
    // },
    
  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
if(window.gtag){
  gtag('config', 'G-0B4DZ65W51', {'page_path': to.fullPath})
}
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "衣加加管理平台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        Message({
            message: "请先登录~",
            type: 'warning',
            duration: 500
        });
        setTimeout(function() {
            router.replace("/login")
        }, 500)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedYjjAdminMultiActive")
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js